// @core/api/endpoints/license/resume_license.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LicenseResponse,
  ResumeLicenseRequest,
} from '../../../types/license';

const BASE_PATH = '/license';

/**
 * Resume license
 * Resumes a previously suspended license, restoring all entitlements and access. Master-only operation.
 */
export async function ResumeLicense(
  license_id: string,
  data: ResumeLicenseRequest,
  options?: RequestOptions
): Promise<LicenseResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/licenses/:license_id/resume`;
  requestPath = requestPath.replace(':license_id', encodeURIComponent(license_id));
  const requestOptions = options;
  return client.post<LicenseResponse>(requestPath, data, requestOptions);
}
